import React, { useState, useEffect } from 'react';
import { setDateFormat, setTimeFormat } from '../../../services/Commonfunction';
import { PURCHASED_STATUS, cutDecimalPoints } from '../../../constants/Common';
const PurchaseCard = (props) => {
  const [purchase, setPurchase] = useState({});

  useEffect(() => {
    if (props.purchaseData) {
      setDataForPurchase(props.purchaseData);
    }
  }, [props.purchaseData]);
  const setDataForPurchase = (data) => {
    let tempObj = data;
    let totalCarat = 0;
    if (tempObj.memoDetails && tempObj.memoDetails.length !== 0) {
      totalCarat = tempObj.memoDetails.map((item) => item.crt).reduce((prev, curr) => prev + curr, 0);
    }
    tempObj = {
      ...data,
      totalCarats: totalCarat,
    };
    setPurchase({ ...tempObj });
  };
  const statusData = (status) => {
    switch (status) {
      case PURCHASED_STATUS.PENDIND:
        return 'Pending';
      case PURCHASED_STATUS.APPROVED:
        return 'Approved';

      case PURCHASED_STATUS.REJECT:
        return 'Reject';

      case PURCHASED_STATUS.RELEASE:
        return 'Release';

      default:
        return 'Pending';
    }
  };
  return (
    <div className="savedSearchItem">
      <div className="savedSearchHead">
        <div className="searchTitle">{purchase.memoNo}</div>
        <div className="searchTime">
          <span>{purchase.createdAt ? setDateFormat(purchase.createdAt) : '--'}</span>
          <span>{purchase.createdAt ? setTimeFormat(purchase.createdAt) : '--'}</span>
        </div>
      </div>
      <div className="d-flex j-space-between align-items-center">
        <div className="savedSearchDetail">
          <div className="detail">
            <span>STONE</span>
            <span>{purchase.memoDetails && purchase.memoDetails.length !== 0 ? purchase.memoDetails.length : '0'}</span>
          </div>
          <div className="detail">
            <span>CARAT</span>
            <span>{purchase.totalCarats ? cutDecimalPoints(purchase.totalCarats) : '0'}</span>
          </div>
          <div className="detail">
            <span>AMOUNT </span>
            <span>{purchase.totalAmount ? cutDecimalPoints(purchase.totalAmount) : '0'}</span>
          </div>
        </div>
        <div className="cardRightBlobk d-flex align-items-center">
          {/* <a>Detail</a> */}
          <div className={`status ${purchase.status === PURCHASED_STATUS.PENDIND ? 'pending' : 'cancel'}`}>
            {statusData(purchase.status)}
          </div>
        </div>
      </div>
    </div>
  );
};
export default PurchaseCard;
